.mobileBottomNavContainer {
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 66px;
  max-height: 90px;
  -webkit-min-logical-height: 66px;
  -webkit-max-logical-height: 90px;
  z-index: var(--cxy-z-index-mobile-bottom-nav);
}

@media (min-width: 1025px) {
  .mobileBottomNavContainer,
  .mobileBottomNavContainer.enabled {
    display: none;
  }
}

.backdrop {
  position: fixed;
  height: 100%;
  background: var(--cxy-color-black);
  width: 100%;
  top: 0;
  opacity: 0.7;
  z-index: var(--cxy-z-index-below-background);
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
  visibility: visible;
}

.backdrop.off {
  opacity: 0;
  visibility: hidden;
}

.mobileBottomNavContainer .bottomNavigation {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  width: 100%;
  height: 100%;
  background: var(--cxy-color-midnight-blue-600);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.1);
  z-index: var(--cxy-z-index-nav-bar);
}

.mobileBottomNavContainer .bottomNavigation .menuItem,
.mobileBottomNavContainer .bottomNavigation .menuItem a {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  font-family: var(--cxy-font-family-sans);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--cxy-color-white);
  text-align: center;
  text-transform: uppercase;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.01em;
}

.mobileBottomNavContainer .bottomNavigation .menuItem {
  padding: 13px 0 8px 0;
}

.menuItem:hover {
  cursor: pointer;
  background-color: var(--cxy-color-midnight-blue-400);
}

.mobileBottomNavContainer .bottomNavigation .menuItem.active svg {
  color: var(--cxy-color-green-300);
}

.mobileBottomNavContainer .bottomNavigation .menuItem:visited {
  color: var(--cxy-color-white);
  text-decoration: none;
}

.mobileBottomNavContainer .bottomNavigation .menuItem .iconContainer,
.mobileBottomNavContainer .bottomNavigation .menuItem a .iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 30px;
  height: 30px;
}

.mobileBottomNavContainer .bottomNavigation .menuItem .iconContainer.premium {
  width: 30px;
  height: 30px;
}

.mobileBottomNavContainer .bottomNavigation .menuItem .iconContainer .offerCount {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: auto;
  height: 18px;
  min-width: 18px;
  background-color: var(--cxy-color-green-300);
  border-radius: 12px;
  font-family: var(--cxy-font-family-sans);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--cxy-color-midnight-blue-600);
  top: -7px;
  left: 16px;
  padding: 0.9px 0 0 0.5px;
}

.mobileBottomNavContainer .bottomNavigation .menuItem.allSportsButton {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  transition:
    all 0.1s linear,
    margin 0s ease;
  z-index: var(--cxy-z-index-control-highest);
}

.mobileBottomNavContainer .bottomNavigation .menuItem.allSportsButton span {
  transform: scale(1.3);
}

.mobileBottomNavContainer .bottomNavigation .menuItem.allSportsButton.active {
  background: var(--cxy-color-midnight-blue-400);
}

.mobileBottomNavContainer .bottomNavigation .menuItem .allSportsButton.open span {
  margin-top: 0;
  transform: scale(1.2);
  opacity: 0.6;
}
